import { render, staticRenderFns } from "./SettingsCompanyRegistration.vue?vue&type=template&id=4a7a36b9&scoped=true&"
import script from "./SettingsCompanyRegistration.vue?vue&type=script&lang=js&"
export * from "./SettingsCompanyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a36b9",
  null
  
)

export default component.exports